import React from 'react';

import {ChangeFolder} from './ChangeFolder';

import type {BasicTeamSerializedType, FolderSerializedType} from 'sweet-types';

interface Props {
  onClose: () => void;
  item: FolderSerializedType;
  parent?: {teams: Array<BasicTeamSerializedType>};
}

export function EditFolder({item, parent, onClose}: Props) {
  const allowedTeams: Array<BasicTeamSerializedType> = parent?.teams ?? [];

  return (
    <ChangeFolder
      allowedTeams={allowedTeams}
      onCancel={onClose}
      isSelectOnly={item.parent != null}
      folder={item}
    />
  );
}
